import React, { useState } from 'react';
import get from 'lodash/get';
import { ToastNature, ErrorToastText } from '../../common/types';

import { getBusinessListAuthz3, getWorkspaces, getBusinessList } from '../../flows/businessList';
import Toast from '../Toast';

export const useBusinessHierarchy = (isMigratedToAuthz3: boolean) => {
  const [businessHierarchy, setBusinessHierarchy] = useState('');

  const business = React.useMemo(
    () => ({
      getBusinessHierarchy: async () => {
        return;
        if (isMigratedToAuthz3) {
          const workspaces = await getWorkspaces()
          if (workspaces.data.workspaces) {
            const defaultWorkSpace = workspaces.data.workspaces.filter(
              (workspace: any) => workspace.isDefault
            );
            const workspaceId = get(defaultWorkSpace, '[0].workspaceNode.id', '');
            getBusinessListAuthz3('WORKSPACE', workspaceId)
              .then((response: any) => {
                setBusinessHierarchy(response);
              })
              .catch((error) => {
                Toast.notify({
                  description: ErrorToastText.HIERARCHY,
                  nature: ToastNature.ERROR,
                });
              });
        }
        } else {
          getBusinessList()
          .then((response: any) => {
            setBusinessHierarchy(response);
          })
          .catch((error) => {
            Toast.notify({
              description: ErrorToastText.HIERARCHY,
              nature: ToastNature.ERROR,
            });
          });
        }
      },
    }),
    []
  );

  return { businessHierarchy, business };
};
